@if (isSegmentMode()) {
	<app-navbar title="Listy"></app-navbar>
} @else {
	<app-top-bar
		[transportId]="store.transport()?.id"
		[module]="TransportModule.LIST"
		[side]="store.transport()?.side ?? TransportSide.DEPARTURE"
		[buttonsDisabled]="store.transportAction() === TransportAction.ADD"
		[transportName]="store.transport()?.name"
		[kind]="store.transport()?.kind"
		[transportsToLinkNames]="store.transportsToLinkNames()"
	>
	</app-top-bar>
}

<mat-tab-group>
	<mat-tab>
		<ng-template mat-tab-label>Docelowa</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.TARGET_LIST"
			[columns]="targetListColumns()"
			[transportSide]="tableTransportSide()"
			[data]="tableData()"
		></app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>Paszportowa</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.PASSPORT_LIST"
			[columns]="passportListColumns"
			[transportSide]="tableTransportSide()"
			[data]="tableData()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>Opłaty</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.FEE"
			[columns]="feeColumns"
			[transportSide]="tableTransportSide()"
			[data]="tableData()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>TGS</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.TGS"
			[columns]="tgsColumns"
			[transportSide]="tableTransportSide()"
			[data]="tableData()"
		>
		</app-transport-list-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>SMS</ng-template>
		<app-transport-list-table
			[tabType]="ListTabType.SMS"
			[columns]="smsColumns"
			[transportSide]="tableTransportSide()"
			[data]="tableData()"
			(refreshView)="refreshView()"
		>
		</app-transport-list-table>
	</mat-tab>
</mat-tab-group>
